/**
 * ==========================================================
 * MASAFI BANNER GRID
 * Mobile Slider Navigation
 * ==========================================================
 */

class MasafiBannerGrid {
  constructor(section) {
    this.section = section;
    this.slider = section.querySelector(".banner-grid");
    this.dotsContainer = section.querySelector(".banner-dots");

    if (!this.slider || !this.dotsContainer) return;

    this.slides = [...this.slider.querySelectorAll(".banner-card")];

    if (this.slides.length <= 1) {
      this.dotsContainer.style.display = "none";
      return;
    }

    this.createDots();
    this.bindEvents();
    this.updateActiveDot();
  }

  createDots() {
    this.dotsContainer.innerHTML = "";

    this.slides.forEach((slide, index) => {
      const dot = document.createElement("button");

      dot.type = "button";
      dot.className = "banner-dot";
      dot.setAttribute("aria-label", `Go to slide ${index + 1}`);

      dot.addEventListener("click", () => {
        this.slider.scrollTo({
          left: slide.offsetLeft,
          behavior: "smooth"
        });
      });

      this.dotsContainer.appendChild(dot);
    });

    this.dots = [...this.dotsContainer.querySelectorAll(".banner-dot")];
  }

  bindEvents() {
    let timeout;

    this.slider.addEventListener("scroll", () => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        this.updateActiveDot();
      }, 40);
    });

    window.addEventListener("resize", () => {
      this.updateActiveDot();
    });
  }

  updateActiveDot() {
    if (!this.dots) return;

    const scrollLeft = this.slider.scrollLeft;
    const slideWidth = this.slider.clientWidth;

    const activeIndex = Math.round(scrollLeft / slideWidth);

    this.dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === activeIndex);
    });
  }
}

/* ==========================================================
   Initialize
========================================================== */

function initMasafiBannerGrid() {
  document
    .querySelectorAll(".masafi-banner-grid")
    .forEach(section => {
      if (!section.dataset.initialized) {
        new MasafiBannerGrid(section);
        section.dataset.initialized = "true";
      }
    });
}

document.addEventListener("DOMContentLoaded", initMasafiBannerGrid);

/* Shopify Theme Editor Support */

document.addEventListener("shopify:section:load", initMasafiBannerGrid);
document.addEventListener("shopify:section:reorder", initMasafiBannerGrid);